import {API} from '../../Services';

async function CheckinData(code){
    let token =  localStorage.getItem('token');

    // let mallIdArr = code.split("mc_");

    let splitArray = code.split('_');
    if(splitArray[0] ==="mc"){
        return API.post(`/users/check-ins`,{uid:splitArray[1]},{headers: { 'Authorization':  `Bearer ${token}`}});
    }

    if(splitArray[0] ==="me"){
        return API.post(`/users/merchant-check-ins`,{uid:splitArray[1]},{headers: { 'Authorization':  `Bearer ${token}`}});
    }


}

export {CheckinData};
